/**
 * Decide se um recurso restrito a guildas deve aparecer para o participante.
 *
 * O payload de `/gamification/data` passou a trazer o conteúdo do evento sem
 * recorte por participante — um payload por versão, cacheável inteiro. Quem
 * decide o que aparece é o cliente, a partir de `guild_ids` do recurso e das
 * guildas do progresso.
 *
 * Esta é a metade de exibição da regra. A outra metade é imposta no servidor,
 * em `Gamification::ResourceEligibilityService`, e é ela que vale: ocultar aqui
 * é conveniência de interface, não barreira. As duas precisam concordar — se
 * divergirem, o participante vê algo que não consegue concluir, ou não vê algo
 * que poderia.
 *
 * Critério de quando derivar no cliente: `shared/lib/derivation/CRITERIO.md`.
 */
export interface GuildRestricted {
  guild_ids?: number[] | null
}

/**
 * Recurso sem restrição é visível para todo participante do evento. Recurso
 * restrito exige que o participante esteja em ao menos uma das guildas.
 */
export const isVisibleForGuilds = (
  resource: GuildRestricted,
  participantGuildIds: number[] | null | undefined
): boolean => {
  const restriction = resource?.guild_ids ?? []

  if (restriction.length === 0) return true

  const owned = participantGuildIds ?? []
  if (owned.length === 0) return false

  return restriction.some(guildId => owned.includes(guildId))
}

export const filterVisibleForGuilds = <T extends GuildRestricted>(
  resources: T[] | null | undefined,
  participantGuildIds: number[] | null | undefined
): T[] => (resources ?? []).filter(resource => isVisibleForGuilds(resource, participantGuildIds))
